import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Form, Input, InputNumber, Modal, Switch, message } from 'antd';
import { getWithdrawalAvailability, updateWithdrawalAvailability } from '../../api/systemConfig';

export default function WithdrawalAvailability() {
  const [form] = Form.useForm();
  const [policy, setPolicy] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const load = useCallback(async () => {
    try {
      const data = await getWithdrawalAvailability();
      setPolicy(data);
      form.setFieldsValue(data);
      setError('');
    } catch (failure) {
      setError('提现开放配置加载失败，请重试');
      setPolicy(null);
    }
  }, [form]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    let values;
    try { values = await form.validateFields(); } catch (_) { return; }
    const persist = async () => {
      setSaving(true);
      try {
        const updated = await updateWithdrawalAvailability({ ...values,
          maximumVersionCode: values.maximumVersionCode ?? null, version: policy.version });
        setPolicy(updated);
        form.setFieldsValue(updated);
        message.success('提现开放配置已更新');
      } catch (failure) {
        message.error(failure?.message || '保存失败，请刷新配置后重试');
      } finally { setSaving(false); }
    };
    if (values.enabled) {
      Modal.confirm({ title: '确认开放提现？',
        content: '请确认平台转账服务已开通，并已完成真实转账和结果核对。保存后，符合版本条件的用户无需升级即可申请提现。',
        okText: '已验证，开放提现', cancelText: '取消', onOk: persist });
    } else await persist();
  };

  return (
    <div>
      <div className="config-section-heading">
        <div><h3>提现开放配置</h3><p>控制是否接受新提现申请。关闭时保留余额及历史申请，放开后用户无需再次升级。</p></div>
        <Button onClick={load} disabled={saving}>刷新开放配置</Button>
      </div>
      {error ? <Alert type="error" message={error} /> : null}
      <Form form={form} layout="vertical" disabled={!policy || saving}>
        <Form.Item name="enabled" label="开放提现" valuePropName="checked"><Switch aria-label="开放提现" /></Form.Item>
        <div className="withdrawal-policy-row">
          <Form.Item name="minimumVersionCode" label="最低 Android 版本号（versionCode）"
            rules={[{ required: true, message: '请输入最低版本号' }]}>
            <InputNumber min={0} max={2147483647} precision={0} />
          </Form.Item>
          <Form.Item name="maximumVersionCode" label="最高 Android 版本号（留空不限）"
            dependencies={['minimumVersionCode']}
            rules={[({ getFieldValue }) => ({ validator: (_, value) => value == null || value >= getFieldValue('minimumVersionCode')
              ? Promise.resolve() : Promise.reject(new Error('最高版本不能低于最低版本')) })]}>
            <InputNumber min={0} max={2147483647} precision={0} />
          </Form.Item>
        </div>
        <p>最低版本为 0 且最高版本留空表示全量；限定范围时仅允许报告有效版本的 Android 客户端。</p>
        <Form.Item name="title" label="不可用弹窗标题" rules={[{ required: true, whitespace: true, max: 60 }]}>
          <Input maxLength={60} />
        </Form.Item>
        <Form.Item name="message" label="不可用弹窗说明" rules={[{ required: true, whitespace: true, max: 500 }]}>
          <Input.TextArea rows={3} maxLength={500} showCount />
        </Form.Item>
        <Button type="primary" onClick={save} loading={saving} disabled={!policy}>保存提现开放配置</Button>
      </Form>
    </div>
  );
}
